export const QUESTION_TYPE_MCQ = 'MCQ';
export const QUESTION_TYPE_TEXT = 'text';
export const QUESTION_TYPE_MULTISELECT = 'MultiSelect';

export const INT_TYPE = 'int';
export const STRING_TYPE = 'str';

export const WIDGET_TYPE = {
	POLL: 'POLLS', // type 5
	SURVEY: 10,
	BANNER: 3,
	_4: 4,
	_9: 9,
	_12: 12,
	_3: 3,
};

export const spinningWheelData = [
	{
		image: {
			uri: 'https://images.kiranaclub.ai/widget3/May/27/10c3a726-5afd-4565-a4ee-6de260d283fa/1779877847962.webp?blurhash=VVNFOlBodDcwMFZAXzFzOlIuV1gtcGpda0N0Nn5xb2c5R1ZA&width=281&height=237&aspect_ratio=0.8434',
		},
	},
	{
		image: {
			uri: 'https://images.kiranaclub.ai/widget3/May/27/4eac8c62-a6b6-493d-9b00-d39272f96f3c/1779877847930.webp?blurhash=VW5JNDtNTXw0OnQ2P3dXQXd1UislTVdVdDhhZXI9YXl4XVdC&width=282&height=301&aspect_ratio=1.0674',
		},
	},
	{
		image: {
			uri: 'https://images.kiranaclub.ai/widget3/May/27/102b8b46-8645-4e8a-8d59-dca398291656/1779877847845.webp?blurhash=VU9FQyxfV0IwMGZSfm5qW1I7Umo%2FYVdWeHVqdC09V0Jve29m&width=282&height=301&aspect_ratio=1.0674',
		},
	},
	{
		image: {
			uri: 'https://images.kiranaclub.ai/widget3/May/27/d23cfc78-7fb5-4e3a-8f7b-574f64980855/1779877847334.webp?blurhash=VUhGaCNUbiswMFg0LmxiSG0tYWUuOGFfczpvND9aYWVucHRR&width=281&height=300&aspect_ratio=1.0676',
		},
	},
	{
		image: {
			uri: 'https://images.kiranaclub.ai/widget3/May/27/56cfce9d-97ae-422a-9a0a-79a5d1d90f84/1779877848077.webp?blurhash=VThFXzphWG0wMG1sR1pyP1ZzSzR1aWpbRE9qW18zV1daaHhG&width=282&height=241&aspect_ratio=0.8546',
		},
	},
	{
		image: {
			uri: 'https://images.kiranaclub.ai/widget3/May/27/a0320f05-8fea-4560-a33a-3c692ef86125/1779877848384.webp?blurhash=VTdDUDtlSXAwMC1Tfm5vSi1yTkhEJHhERCVKQ0RPT0cwTD1Y&width=282&height=345&aspect_ratio=1.2234',
		},
	},
];

export const WEBVIEW_EVENTS = {
	SLOT_MACHINE_ATTEMPTS: 'slot-machine-attempts-exhausted',
	INSUFFICIENT_COIN_BALANCE: 'insufficient-coin-balance',
	NAVIGATION: 'navigation',
	GO_BACK: 'go-back',
	PUSH: 'push',
	DISPATCH: 'dispatch',
	DOWNLOAD_FILE: 'download-file',
	GET_CAMERA_PERMISSION: 'get-camera-permission',
	GET_LOCATION_PERMISSION: 'get-location-permission',
	OPEN_GALLERY: 'open-gallery',
	OPEN_CAMERA: 'open-camera',
	VIDEO_COMPRESS: 'video-compress',
	IMAGE_COMPRESS: 'image-compress',
	GET_VIDEO_META: 'get-video-meta',
	UPLOAD_BACKGROUND_VIDEO: 'upload-background-video',
	SHARE_IMAGE: 'share-image',
	MP_TRACK: 'mp-track', // → native mixpanel.track(eventName, properties)
	// Webview → RN: page-load perf milestones (ms since navigation start), sent
	// once per document load after the React shell mounts. The native host merges
	// them into its 'WebView Loaded' Mixpanel event. See reportWebviewPerf().
	WEBVIEW_PERF: 'webview-perf',
	// Webview → RN: native mic recording bridge. The native AudioRecorderModule
	// drives Android MediaRecorder (bypasses the getUserMedia path that fails with
	// NotReadableError inside react-native-webview). Payload `{ qid, requestId }`
	// is echoed back on the matching RN_TO_WEBVIEW_EVENTS.AUDIO_RECORDING_* event.
	START_AUDIO_RECORDING: 'start-audio-recording',
	STOP_AUDIO_RECORDING: 'stop-audio-recording',
	CANCEL_AUDIO_RECORDING: 'cancel-audio-recording',
	// Webview → RN: declare whether this page wants to own the Android hardware
	// back press. Payload `{ enabled: boolean }`. When enabled, the native host
	// forwards HARDWARE_BACK_PRESS into the WebView instead of popping its own
	// stack, letting us run custom back logic. See useHardwareBack().
	REGISTER_BACK_HANDLER: 'register-back-handler',
	// Webview → RN: confirms an RN_TO_WEBVIEW_EVENTS.NAVIGATE request was
	// applied by the SPA router. Payload `{ nonce, path }` echoes the request's
	// nonce so the host can match ack ↔ request; no ack ⇒ the host falls back
	// to a full document load. See components/bridge-navigation.
	NAVIGATE_ACK: 'kc-navigate-ack',
};

// Daily Stories (IG-style viewer) — Mixpanel event names fired via the RN bridge
export const STORY_EVENTS = {
	VIEWED: 'Story Viewed',
	CTA_CLICK: 'Story CTA Click',
	CLOSED: 'Story Closed',
};

export const KYC_PENDING = 'Pending';

export const KYC_REJECT = 'Rejected';

export const KYC_APPROVED = 'Approved';

export const CLAIMED = 'Claimed';

export const UNCLAIMED = 'Unclaimed';

export const PROCESSING = 'Processing';

export const RN_TO_WEBVIEW_EVENTS = {
	// RN → Webview: hardware back was pressed while this page had a back handler
	// registered. Run custom logic (close overlay / pop SPA route); if nothing is
	// left to handle, call goBack() so the native stack pops. See useHardwareBack().
	HARDWARE_BACK_PRESS: 'hardware-back-press',
	// RN → Webview: ask the SPA to client-side-navigate a preloaded/parked
	// WebView instance instead of doing a full document load. Payload
	// `data: { path, search?, nonce }`; the page replies with
	// WEBVIEW_EVENTS.NAVIGATE_ACK once the route is actually applied.
	// See components/bridge-navigation.
	NAVIGATE: 'kc-navigate',
	// RN → Webview: arrives as a `window` CustomEvent (NOT a 'message'
	// MessageEvent) when the host reveals an already-loaded instance; detail is
	// `{ preloaded: boolean, age_ms: number }`. Stale pages use it to refresh
	// on-screen React Query data. See components/bridge-navigation.
	WEBVIEW_SHOWN: 'kc-webview-shown',
	OPEN_CAMERA_COMPLETE: 'open-camera-complete',
	OPEN_GALLERY_COMPLETE: 'open-gallery-complete',
	GET_VIDEO_META_COMPLETE: 'get-video-meta-complete',
	VIDEO_COMPRESS_PROGRESS: 'video-compress-progress',
	IMAGE_COMPRESS_COMPLETE: 'image-compress-complete',
	VIDEO_COMPRESS_COMPLETE: 'video-compress-complete',
	// RN → Webview: native mic recording results. STARTED confirms the recorder
	// is live; COMPLETE carries `{ qid, requestId, base64, mime, ext, durationMs,
	// size }`; ERROR carries `{ qid, requestId, code, message }`.
	AUDIO_RECORDING_STARTED: 'audio-recording-started',
	AUDIO_RECORDING_COMPLETE: 'audio-recording-complete',
	AUDIO_RECORDING_ERROR: 'audio-recording-error',
};

export const CHAT_CONTENT_TYPE = {
	TEXT: 'TEXT',
	IMAGE: 'IMAGE',
};

export const CHAT_SELF_NAME = 'You';

export const BRAND_PROFILE_SCREEN_NAME = 'BrandProfile';

export const studyDemoQuestions = {
	status: 'OK',
	data: {
		user_id: '',
		survey_id: 4,
		data: {
			questions: [
				{
					id: 0,
					options: [
						{
							id: 0,
							label: 'Hindustan Unilever (HUL)',
							value: 'Hindustan Unilever (HUL)',
						},
						{
							id: 1,
							label: 'Dabur',
							value: 'Dabur',
						},
						{
							id: 2,
							label: "Hershey's",
							value: "Hershey's",
						},
						{
							id: 3,
							label: 'Nestle',
							value: 'Nestle',
						},
						{
							id: 4,
							label: 'Cadbury',
							value: 'Cadbury',
						},
						{
							id: 5,
							label: 'Godrej',
							value: 'Godrej',
						},
						{
							id: 6,
							label: 'Coca Cola',
							value: 'Coca Cola',
						},
						{
							id: 7,
							label: 'कोई भी नहीं ',
							value: 'कोई भी नहीं ',
						},
					],
					question: 'इनमें से किन ब्रांड के सेल्समैन आपके पास आते है?',
					submit_key: 'आगे बढ़ें',
					survey_name: 'VisiBoost_Profiling',
					next_question: 2,
					question_type: 'multiple_select_question',
				},
				{
					id: 2,
					options: [
						{
							id: 0,
							label: 'फ्रिज (VisiCooler)',
							value: 'फ्रिज (VisiCooler)',
							image_url:
								'https://images.kiranaclub.ai/widget3/May/27/5c55d367-3956-4968-b0fe-947c781a4739/1779877840214.webp?blurhash=VV1RY0Msb0xfTmJ2b2ZqdGpaYkh4dWJIUmpqWmpaZmtrQ2F5&width=296&height=296&aspect_ratio=1.0000',
						},
						{
							id: 1,
							label: 'टेबल टॉप',
							value: 'टेबल टॉप',
							image_url:
								'https://images.kiranaclub.ai/widget3/May/27/bfc84f29-5129-4432-a89d-80cc1a6203d2/1779877839785.webp?blurhash=VXhPek1YUmp%2BcSVNeHVSampzb3o%2FYm9mSVVXQ24kdDdSKlZA&width=296&height=296&aspect_ratio=1.0000',
						},
						{
							id: 2,
							label: 'खड़ा स्टैंड / रैक',
							value: 'खड़ा स्टैंड / रैक',
							image_url:
								'https://images.kiranaclub.ai/widget3/May/27/3dd04020-3457-4187-9c47-48380662b572/1779877839984.webp?blurhash=VXdMfE0sJUw%2FXlIrTXlSUFdCb3pvfG96biRWQGpaaltrVm9m&width=296&height=296&aspect_ratio=1.0000',
						},
						{
							id: 3,
							label: 'कोई भी नहीं',
							value: 'कोई भी नहीं',
						},
					],
					question: 'आपके पास कंपनी द्वारा दी गयीं कौनसी चीज़ें हैं?',
					submit_key: 'आगे बढ़ें',
					survey_name: 'VisiBoost_Profiling',
					next_question: 3,
					question_type: 'multiple_select_question_image',
				},
				{
					id: 3,
					options: [
						{
							id: 0,
							label: 'हाँ',
							value: 'हाँ',
							next_question: 4,
						},
						{
							id: 1,
							label: 'नहीं',
							value: 'नहीं',
							next_question: 4,
						},
					],
					question:
						'क्या आपको कभी किसी कंपनी ने उनके प्रोडक्ट डिस्प्ले पर लगाने के लिए पैसे या बिल पर छुट दी?',
					submit_key: 'आगे बढ़ें',
					survey_name: 'VisiBoost_Profiling',
					question_type: 'single_select_question',
				},
				{
					id: 4,
					options: [
						{
							id: 0,
							label: 'हाँ',
							value: 'हाँ',
							next_question: 5,
						},
						{
							id: 1,
							label: 'नहीं',
							value: 'नहीं',
							next_question: 5,
						},
						{
							id: 2,
							label: 'मुझे सेल्समैन की मदद की ज़रूरत पड़ेगी',
							value: 'मुझे सेल्समैन की मदद की ज़रूरत पड़ेगी',
							next_question: 5,
						},
					],
					question:
						'अगर कंपनी आपको खुदसे प्रोडक्ट डिस्प्ले पर लगाने के लिए पैसे दे, तो क्या आप कर पाएंगे?',
					submit_key: 'आगे बढ़ें',
					survey_name: 'VisiBoost_Profiling',
					question_type: 'single_select_question',
				},
				{
					id: 5,
					options: [
						{
							id: 0,
							label: 'शेल्फ/अलमारी का 1-2 खंड',
							value: 'शेल्फ/अलमारी का 1-2 खंड',
							image_url:
								'https://images.kiranaclub.ai/widget3/May/27/de6082de-ef7a-409e-9e80-80ecbace0128/1779877839582.webp?blurhash=VWVITE1UUi5%2BcXQ3JTJvSmJiZmxXWG9kb2VXQ1JpYklvZmFl&width=296&height=296&aspect_ratio=1.0000',
						},
						{
							id: 1,
							label: 'हैंगर (लड़िया)',
							value: 'हैंगर (लड़िया)',
							image_url:
								'https://images.kiranaclub.ai/widget3/May/27/42ef085c-037f-4d13-b27a-c90e0db86bfd/1779877815381.webp?blurhash=VU9IZVVXP3dYb3hzeFdzK05MV1RJcXMqamNvZi1OTk1venQ2&width=706&height=637&aspect_ratio=0.9023',
						},
						{
							id: 2,
							label: 'खड़ा स्टैंड / रैक',
							value: 'खड़ा स्टैंड / रैक',
							image_url:
								'https://images.kiranaclub.ai/widget3/May/27/3dd04020-3457-4187-9c47-48380662b572/1779877839984.webp?blurhash=VXdMfE0sJUw%2FXlIrTXlSUFdCb3pvfG96biRWQGpaaltrVm9m&width=296&height=296&aspect_ratio=1.0000',
						},
						{
							id: 3,
							label: 'टेबल टॉप',
							value: 'टेबल टॉप',
							image_url:
								'https://images.kiranaclub.ai/widget3/May/27/bfc84f29-5129-4432-a89d-80cc1a6203d2/1779877839785.webp?blurhash=VXhPek1YUmp%2BcSVNeHVSampzb3o%2FYm9mSVVXQ24kdDdSKlZA&width=296&height=296&aspect_ratio=1.0000',
						},
						{
							id: 4,
							input: 'string',
							label: 'अन्य (कृपया लिखे)',
							value: 'अन्य (कृपया लिखे)',
							on_select: 'open_text_box',
							max_length: 100,
						},
					],
					question: 'आप प्रोडक्ट को किस तरह से डिस्प्ले पर लगा सकते है?',
					submit_key: 'आगे बढ़ें',
					survey_name: 'VisiBoost_Profiling',
					next_question: 7,
					question_type: 'multiple_select_question_image',
				},
				{
					id: 7,
					options: [
						{
							id: 0,
							label: 'हाँ',
							value: 'हाँ',
							next_question: 9,
						},
						{
							id: 1,
							label: 'नहीं',
							value: 'नहीं',
							next_question: 9,
						},
					],
					question: 'क्या आपके पास GST नंबर है?',
					submit_key: 'आगे बढ़ें',
					survey_name: 'VisiBoost_Profiling',
					question_type: 'single_select_question',
				},
				{
					id: 9,
					options: {
						id: 0,
					},
					question: 'अपनी दुकान की अंदर से 2 फोटो खींचे',
					submit_key: 'आगे बढ़ें',
					survey_name: 'VisiBoost_Profiling',
					no_of_images: 2,
					next_question: 10,
					question_type: 'image_upload',
					preview_content:
						'https://images.kiranaclub.ai/widget3/May/27/733b5bba-4bcb-46fa-afb5-e0c9bd3b11e5/1779877839525.webp?blurhash=VUFFZkReNG94XVZbfldNdy09Tkd0OURpdFJOYX5vYWlqR1ZA&width=540&height=792&aspect_ratio=1.4667',
					question_sub_text: 'दोनों फोटो अलग-अलग दिशाओं से खींचे। कृपया सेल्फ़ी नहीं खींचे 🙏',
				},
				{
					id: 10,
					options: {
						id: 0,
					},
					question: 'अपनी दुकान की बाहर से 2 फोटो खींचे',
					submit_key: 'आगे बढ़ें',
					survey_name: 'VisiBoost_Profiling',
					no_of_images: 2,
					next_question: 11,
					question_type: 'image_upload',
					preview_content:
						'https://images.kiranaclub.ai/widget3/May/27/204ec653-4933-432d-8b30-eeeba139d7f2/1779877839093.webp?blurhash=VUxHK0UqWFVEJElWJSVXRlJQUio%2Fd04xSVV4dFhvJUxNd296&width=521&height=694&aspect_ratio=1.3321',
					question_sub_text: 'एक फोटो में दुकान के साथ-साथ दुकान का बोर्ड भी आना चाहिए।',
				},
				{
					id: 11,
					options: {
						id: 0,
					},
					question: 'अपनी दुकान का एक अंदर-बाहर से वीडियो बनाये',
					submit_key: 'आगे बढ़ें',
					survey_name: 'VisiBoost_Profiling',
					next_question: 12,
					question_type: 'video_upload',
					preview_content:
						'https://images.kiranaclub.ai/widget3/May/27/42ba4c43-335e-4f65-8533-d99182d854ef/1779877817715.mp4',
					question_sub_text:
						'आपकी दुकान के अनुसार आपको पैसे मिलेंगे, कृपया उदाहरण में दिया वीडियो देखें 👉',
				},
				{
					id: 12,
					options: {
						id: 0,
					},
					question: 'आप हर हफ्ते दुकान के लिए लगभग कितने की ख़रीदी करते हैं?',
					submit_key: 'आगे बढ़ें',
					survey_name: 'VisiBoost_Profiling',
					next_question: 13,
					question_type: 'short_answer',
				},
				{
					id: 13,
					options: {
						id: 0,
					},
					question: 'आप एक महीने में लगभग कितने की बिक्री कर लेते है? (मासिक टर्नओवर)',
					submit_key: 'आगे बढ़ें',
					survey_name: 'VisiBoost_Profiling',
					next_question: -1,
					question_type: 'short_answer',
				},
			],
			start_question: 0,
		},
	},
};

// ── File size limits (bytes) ─────────────────────────────────────
export const MAX_FILE_SIZE_100MB = 104857600; // 100 MB
export const MAX_FILE_SIZE_500MB = 524288000; // 500 MB
export const MAX_FILE_SIZE_1GB = 1024 * 1024 * 1024; // 1 GB

// ── Input validation ─────────────────────────────────────────────
export const PHONE_NUMBER_MAX_DIGITS = 10;

// ── Shared post creation limits ──────────────────────────────────
export const PRODUCT_NAME_MAX_LENGTH = 100;
export const SCHEME_DESCRIPTION_MAX_LENGTH = 300;
export const MAX_VIDEO_UPLOAD_RETRIES = 5;

// A large/long video legitimately takes minutes to upload, so we never cap total
// upload time. The upload is aborted only when it makes NO progress for this long —
// a genuinely stuck socket — so the caller's retry can take over instead of the
// spinner hanging forever. See src/config/gcpconfig.js.
export const UPLOAD_STALL_TIMEOUT_MS = 30000;
// The signed-URL request is a tiny JSON call; abort and retry if it hangs this long.
export const SIGNED_URL_TIMEOUT_MS = 15000;

// ── React Query defaults ─────────────────────────────────────────
export const QUERY_CACHE_TIME_10MIN = 600000; // 10 minutes
